// extracted by mini-css-extract-plugin
export default {"root":"ClearFilters_root__QHAD1"};